<script>
import * as BIZ_API from '@/api/biz'
export default {
  name: "BizDrawer",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible(val) {
      this.$emit("update:visible", val);
      if (val) {
        this.getList()
      }
    }
  },
  data() {
    return {
      queryFrom: {
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      loading: false,
      list: [],

      routeVisible: false,
      routeTitle: '',
      routeForm: {
        bizType: '1',
        formName: '',
        createRoute: '',
        detailRoute: '',
        remark: ''
      },
      routeFormRule: {
        formName: [{ required: true, message: '请输入审批模块名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    getList() {
      this.loading = true;
      BIZ_API.listBpmBusinessForm(this.queryFrom).then(res => {
        this.list = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    handleDeleteRoute(row) {
      this.$confirm('是否确认删除名称为"' + row.formName + '"的数据项?', "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          BIZ_API.delBpmBusinessForm(row.id).then(res => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getList();
          });
        });
    },
    handleAddRoute() {
      this.routeVisible = true;
      this.routeTitle = '审批业务表单路由添加';
    },
    handleEditRoute(row) {
      this.routeVisible = true;
      this.routeTitle = '审批业务表单路由编辑';
      this.routeForm = {
        id: row.id,
        formName: row.formName,
        bizType: row.bizType,
        createRoute: row.createRoute,
        detailRoute: row.detailRoute,
        remark: row.remark
       };
    },
    handleSubmitRoute() {
      this.$refs.routeFormRef.validate(valid => {
        if (valid) {
          if(this.routeForm.id){
            BIZ_API.updateBpmBusinessForm(this.routeForm).then(res => {
              this.routeVisible = false;
              this.resetRouteForm();
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.getList();
            });
          }else{
            BIZ_API.addBpmBusinessForm(this.routeForm).then(res => {
              this.routeVisible = false;
              this.resetRouteForm();
              this.$message({
                message: '新增成功',
                type: 'success'
              });
              this.getList();
            });
          }
        }
      });
    },
    resetRouteForm() {
      this.routeForm = {
        id: undefined,
        formName: '',
        bizType: '1',
        createRoute: '',
        detailRoute: '',
        remark: ''
      };
      this.$nextTick(() => {
        if (this.$refs.routeFormRef) {
          this.$refs.routeFormRef.clearValidate();
        }
      });
    },
    handleCloseRouteDialog() {
      this.routeVisible = false;
      this.resetRouteForm();
    },
    handleCloseBizDialog() {
      this.visible = false;
    }
  }
}
</script>

<template>
  <div>
    <el-drawer :visible.sync="visible" direction="rtl" :before-close="handleCloseBizDialog"
      :close-on-press-escape="false" :show-close="false" :size="1200" :withHeader="false" :modal-append-to-body="false"
      :destroy-on-close="true" custom-class="drawerMain dataEdit">
      <div class="drawerBox">
        <div class="closeDrawer" @click="handleCloseBizDialog">
          <i class="el-icon-close"></i>
        </div>
        <div class="drawerOverflow">
          <div class="title mb20">审批业务表单路由列表</div>
          <div class="section pt20">
            <div class="searchView">
              <span></span>
              <el-button type="primary" @click="handleAddRoute" icon="el-icon-plus" size="small">新增审批路由</el-button>
            </div>
            <div class="tableCont">
              <el-table :data="list" v-loading="loading" element-loading-text="加载中" :height="'100%'">
                <el-table-column label="审批模块名称" prop="formName" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="提交路由地址" prop="createRoute" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="查看路由地址" prop="detailRoute" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="备注" prop="remark" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="创建信息" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div style="display: flex; flex-direction: column; align-items: center;">
                    <span>{{ scope.row.createBy }}</span>
                    <span>{{ scope.row.createTime | timestampFormatDate }}</span>
                  </div>
                  </template>
                </el-table-column>
                <el-table-column label="更新信息" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div style="display: flex; flex-direction: column; align-items: center;">
                    <span>{{ scope.row.modifyBy }}</span>
                    <span>{{ scope.row.modifyTime | timestampFormatDate }}</span>
                  </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-link style="margin: 0 5px;" :underline="false" type="primary" @click="handleEditRoute(scope.row)">编辑</el-link>
                    <el-link style="margin: 0 5px;" :underline="false" type="danger" @click="handleDeleteRoute(scope.row)">删除</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <pagination :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :total="total" :page.sync="queryFrom.pageNum"
              :limit.sync="queryFrom.pageSize" @pagination="getList" />
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="routeVisible" :title="routeTitle" >
      <el-form label-position="top" :model="routeForm" :rules="routeFormRule" ref="routeFormRef">
        <el-form-item label="审批模块名称" prop="formName">
          <el-input v-model="routeForm.formName" placeholder="输入审批模块名称"></el-input>
        </el-form-item>
        <el-form-item label="业务类型" prop="bizType">
          <el-select v-model="routeForm.bizType" placeholder="选择业务类型">
            <el-option value="1" label="训练计划"></el-option>
            <el-option value="2" label="日总结"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提交路由地址">
          <el-input v-model="routeForm.createRoute" placeholder="输入提交路由地址"></el-input>
        </el-form-item>
        <el-form-item label="查看路由地址">
          <el-input v-model="routeForm.detailRoute" placeholder="输入查看路由地址"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="routeForm.remark" placeholder="输入备注" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseRouteDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmitRoute">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.searchView {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.tableCont {
  flex: 1;
  min-height: 0;
}

::v-deep .drawerMain {
  overflow: inherit !important;

  .el-drawer__body {
    overflow: inherit !important;
  }
}

.closeDrawer {
  position: absolute;
  width: 40px;
  height: 45px;
  left: -40px;
  top: 200px;
  background-color: rgba(245, 154, 35, 1);
  font-size: 20px;
  color: #fff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s all linear;

  &:hover {
    opacity: 0.7;
    transition: 0.3s all linear;
  }
}

.drawerBox {
  height: 100%;

  .drawerOverflow {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .title {
      padding-left: 5px;
      font-size: 15px;
      border-left: 3px solid #1890FF;
      color: rgba(255, 255, 255, .8);
      font-weight: bold;
    }

    .section {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
